module.exports = __webpack_public_path__ + "assets/webgl/Concrete_Wall_glossiness.86f336b9.jpg";